import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Dashboard from "../Dashboard/DasboardPage";
import Notifications from "components/layout/Notifications";
import headerStyles from "components/layout/HeaderProfile.module.scss";

const StandaloneDashboard = () => {
    const user = useSelector((state) => state?.auth?.userClaims?.Firstname);

    useEffect(() => {
        document.title = "Dashboard - Linq Law Hub";
    });

    return (
        <div style={{ backgroundColor: "var(--bs-body-bg)" }}>
            <div className="d-flex justify-content-between align-items-center px-4 py-2 pt-4 sticky-top">
                <div className="app-bar-title ps-4">
                    <h4 className="fw-semibold mb-1">Hello, {user}!</h4>
                    <h5 className="mt-0 fs-sm text-secondary">
                        Welcome to Linq Legal Systems
                    </h5>
                </div>
                <div className={`mb-2 position-relative cursor-pointer ${headerStyles["notifications-border"]}`}>
                    <Notifications />
                </div>
            </div>
            <Dashboard />
        </div>
    );
};

export default StandaloneDashboard;
